import { Controller } from "@hotwired/stimulus"

// เลขดาวไทย → เลขสากล เหมือน LandingHelper#arabic_planet (ฝั่ง Ruby) — ลัคนา "ลั" คงไว้ให้ CSS ซ่อน (span.ลั)
const ARABIC_PLANET = {
  "๑": "1", "๒": "2", "๓": "3", "๔": "4", "๕": "5",
  "๖": "6", "๗": "7", "๘": "8", "๙": "9", "๐": "0",
  "น": "N", "พ": "P",
}
const arabicPlanet = (symbol) => ARABIC_PLANET[symbol] || symbol

// วิดเจ็ตวันเกิดบนหน้า landing lagnara — dropdown วัน/เดือน/ปี พ.ศ. + เวลา + เพศ + ไม่ทราบเวลาเกิด
// ส่งไป POST /lakhana (LandingController#lakhana) แล้วโชว์ผลลัคนา + วงดวงกำเนิด + ฤกษ์ยาม ในการ์ดเดิม
// ข้อความ error/คาบเส้น อ่านจาก data-msg-* บน element (แปลตาม locale ฝั่ง ERB)
export default class extends Controller {
  static targets = [
    "day", "month", "year", "time", "gender", "unknownTime",
    "resultContainer", "resultName", "resultEnglish", "resultLayer", "resultCusp",
    "wheel", "resultDithi", "resultDithiValue", "subscribeCta",
    "errorContainer", "errorMessage",
  ]

  toggleUnknownTime() {
    this.timeTarget.disabled = this.unknownTimeTarget.checked
  }

  async calculate(event) {
    event.preventDefault()

    const day = parseInt(this.dayTarget.value, 10)
    const month = parseInt(this.monthTarget.value, 10)
    const yearCE = parseInt(this.yearTarget.value, 10) - 543 // ปีใน dropdown เป็น พ.ศ.
    const unknownTime = this.unknownTimeTarget.checked
    const time = unknownTime ? "07:00" : this.timeTarget.value
    const gender = this.genderTargets.find((r) => r.checked)?.value

    if (!time || !gender) {
      this.showError(this.element.dataset.msgIncomplete)
      return
    }

    // กันวันที่ไม่มีจริง เช่น 30 ก.พ. / 31 เม.ย.
    const check = new Date(yearCE, month - 1, day)
    if (check.getMonth() !== month - 1 || check.getDate() !== day) {
      this.showError(this.element.dataset.msgInvalidDate)
      return
    }

    this.hideError()
    this.resultContainerTarget.classList.add("hidden")

    try {
      const response = await fetch("/lakhana", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          birth_date: `${yearCE}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`,
          birth_time: time,
          gender: gender,
          unknown_birth_time: unknownTime ? "1" : "",
        }),
      })

      const data = await response.json()
      if (response.ok && data.success) {
        this.displayResult(data)
      } else {
        this.showError(data.error || this.element.dataset.msgFailed)
      }
    } catch (error) {
      this.showError(this.element.dataset.msgFailed)
    }
  }

  displayResult(data) {
    this.resultNameTarget.textContent = data.lakhana_name || ""
    this.resultEnglishTarget.textContent = data.lakhana_english || ""

    // ลัคนากำเนิดคือระบบมาตรฐาน ไม่ต้องกำกับ — กำกับเฉพาะสมผุส (เทคนิคที่ยืมมาจากโหราศาสตร์พม่า)
    if (data.active_layer === "สมผุส") {
      this.resultLayerTarget.textContent = this.element.dataset.msgLayerSomphot
      this.resultLayerTarget.classList.remove("hidden")
    } else {
      this.resultLayerTarget.classList.add("hidden")
    }

    if (data.cusp && data.alt_lakhana) {
      this.resultCuspTarget.textContent = this.element.dataset.msgCusp
        .replace("%A", data.lakhana_name)
        .replace("%B", data.alt_lakhana)
      this.resultCuspTarget.classList.remove("hidden")
    } else {
      this.resultCuspTarget.classList.add("hidden")
    }

    this.drawWheel(data.wheel || [])

    if (data.dithi && data.dithi.length > 0) {
      this.resultDithiValueTarget.textContent = data.dithi.join(", ")
      this.resultDithiTarget.classList.remove("hidden")
    } else {
      this.resultDithiTarget.classList.add("hidden")
    }

    this.resultContainerTarget.classList.remove("hidden")
    this.subscribeCtaTarget.classList.remove("hidden")
    this.resultContainerTarget.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }

  // เติมเลขดาว (เลขสากล) ลงช่องราศีของวงดวง — โครง 12 ช่อง .rasi-0..11 เรนเดอร์ไว้ล่วงหน้าฝั่ง ERB แล้ว
  drawWheel(wheel) {
    this.wheelTarget.querySelectorAll(".rasi").forEach((el) => { el.innerHTML = "" })

    wheel.forEach((entry) => {
      const container = this.wheelTarget.querySelector(`.rasi-${entry.rasi}`)
      if (!container) return
      container.innerHTML = (entry.symbol || [])
        .map((s) => `<span class="${s}">${arabicPlanet(s)}</span>`)
        .join("")
    })
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.errorContainerTarget.classList.remove("hidden")
  }

  hideError() {
    this.errorContainerTarget.classList.add("hidden")
  }
}
